import { IAuditEntityData } from "src/app/core/interfaces/iaudit-entity-data";
import { EntityName } from "../../enumerations/entity-name";
import { OperationType } from "../../enumerations/operation-type";
import { LTSAEvergreen } from "../../constants";
import { UnitsLTSA } from "../save/units-ltsa";

export class UnitsLTSADisplay extends UnitsLTSA {
    unitTypeName: string;
    unitStartupDate: string;
    plantId: number | null;
    plantName: string;
    serviceContractorName: string;

    lastUserEmailAddress: string;
    entryUserEmailAddress: string;
    previousUserEmailAddress: string;
    qcUserEmailAddress: string;
    releaseUserEmailAddress: string;
    amendmentUserEmailAddress: string;

    evergreenBool: boolean;
    preferredContractorBool: boolean;

    commentsQcSelected: boolean;
    commentsQcLastDate: string;
    commentsQcLastUser: string;
    commentsQcPrevDate: string;
    commentsQcPrevUser: string;

    private constructor(entity?: any) {
        super(entity);
        this.unitTypeName = entity?.unitTypeName ?? '';
        this.unitStartupDate = entity?.unitStartupDate ?? '';
        this.plantId = entity?.plantId ?? null;
        this.plantName = entity?.plantName ?? '';
        this.serviceContractorName = entity?.serviceContractorName ?? '';
        this.lastUserEmailAddress = entity?.lastUserEmailAddress ?? '';
        this.entryUserEmailAddress = entity?.entryUserEmailAddress ?? '';
        this.previousUserEmailAddress = entity?.previousUserEmailAddress ?? '';
        this.qcUserEmailAddress = entity?.qcUserEmailAddress ?? '';
        this.releaseUserEmailAddress = entity?.releaseUserEmailAddress ?? '';
        this.amendmentUserEmailAddress = entity?.amendmentUserEmailAddress ?? '';

        this.preferredContractorBool = Number(this.preferredContractor) === 1;
        this.evergreenBool = Number(this.contractLength) === LTSAEvergreen.Code;

        this.commentsQcSelected = entity?.commentsQcSelected ?? false;
        this.commentsQcLastDate = entity?.commentsQcLastDate ?? null;
        this.commentsQcLastUser = entity?.commentsQcLastUser ?? null;
        this.commentsQcPrevDate = entity?.commentsQcPrevDate ?? null;
        this.commentsQcPrevUser = entity?.commentsQcPrevUser ?? null;
    }

    static BuildUnitLTSADisplay(entity: any): UnitsLTSADisplay {
        return new UnitsLTSADisplay(entity);
    }

    static BuildNewUnitLTSA(response: any): UnitsLTSADisplay {
        return new UnitsLTSADisplay({
            unitLtsaId: response[0].UNIT_LTSA_ID,
            operation: OperationType.INSERT,
            intDataDepValState: OperationType.INSERT
        });
    }

    get auditEntityBean(): IAuditEntityData {
        return {
            lastUser: this.lastUser,
            entryUser: this.entryUser,
            prevUser: this.prevUser,
            qcUser: this.qcUser,
            lastDate: this.lastDate,
            entryDate: this.entryDate,
            prevDate: this.prevDate,
            qcDate: this.qcDate,
            releaseUser: this.releaseUser,
            releaseDate: this.releaseDate,
            amendmentUser: this.amendmentUser,
            amendmentDate: this.amendmentDate,
            lastUserEmailAddress: this.lastUserEmailAddress,
            entryUserEmailAddress: this.entryUserEmailAddress,
            previousUserEmailAddress: this.previousUserEmailAddress,
            qcUserEmailAddress: this.qcUserEmailAddress,
            releaseUserEmailAddress: this.releaseUserEmailAddress,
            amendmentUserEmailAddress: this.amendmentUserEmailAddress,
            lastUpdateStatus: '',
            entityName: EntityName.UNIT_LTSA,
            entityId: this.unitLtsaId
        };
    }

}
